import React, { useRef } from 'react'
import styles from './User.module.scss'
import { BasicUserData } from './forms/BasicUserData'
import { Button } from 'devextreme-react'
import { ChildFormHandle } from '@/routes/admin/users/user/forms/types'
import { UserInfoPane } from './UserInfoPane'
import { useLoaderData } from 'react-router-typesafe'
import { userRouteLoader } from '@/routes/admin/users/user/User.route'
import notify from 'devextreme/ui/notify'

export function User() {
  const { user } = useLoaderData<typeof userRouteLoader>()
  const basicUserDataHandle = useRef<ChildFormHandle>(null)
  const detailedUserDataHandle = useRef<ChildFormHandle>(null)

  const handleSubmitForms = () => {
    const basicUserDataIsValid = basicUserDataHandle.current?.validate() ?? true
    const detailedUserDataIsValid = detailedUserDataHandle.current?.validate() ?? true
    if (!basicUserDataIsValid || !detailedUserDataIsValid) return

    basicUserDataHandle.current?.submit()
    detailedUserDataHandle.current?.submit()
    notify({
      message: 'Modifiche salvate con successo',
      type: 'success',
      displayTime: 2000,
      closeOnClick: true,
    })
  }

  return (
    <>
      <div className={'content-block'}>
        <div className={`${styles.layoutContainer}`}>
          <div style={{ flex: 1, minWidth: '50%' }}>
            <BasicUserData userId={user.data.id} ref={basicUserDataHandle} />
          </div>
          <div style={{ flex: 1, minWidth: '50%' }}>
            <UserInfoPane infoId={user.data.info?.id} ref={detailedUserDataHandle} />
          </div>
        </div>
        <Button text="Salva" type="success" onClick={handleSubmitForms} />
      </div>
    </>
  )
}
